import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { WaterMarkStyled, StyledImg, StyledLink } from './styles/WaterMarkStyled';

const WaterMark = ({ url, srcWaterMark, size, clickable, onClick }) => (
  <WaterMarkStyled size={size} clickable={clickable} onClick={onClick}>
    <StyledLink href={url}>
      <StyledImg src={srcWaterMark} alt="watermark" />
    </StyledLink>
  </WaterMarkStyled>
);

WaterMark.propTypes = {
  url: PropTypes.string,
  srcWaterMark: PropTypes.string,
  size: PropTypes.string,
  clickable: PropTypes.bool,
  onClick: PropTypes.func,
};

WaterMark.defaultProps = {
  url: null,
  srcWaterMark: null,
  size: null,
  clickable: false,
  onClick: Function.prototype,
};

export default memo(WaterMark);
